import styled from "styled-components";
import { useContentLayoutContext } from "src/website-apps/shared/context/ContentLayoutContext";

const Container = styled.div`
  margin: ${({ theme }) => theme.spacing(7, 0, 7, 0)};
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    margin: ${({ theme }) => theme.spacing(3, 0, 3, 0)};
  }
`;

export const MarginWrapper = ({ children }) => {
  const { pageLayoutEnabled } = useContentLayoutContext();
  if (pageLayoutEnabled) {
    return children;
  }
  return <Container>{children}</Container>;
};
